import { useContext, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { TranslationContext } from '../../../assets/contexts/translationContext';
import {
  TabHistoryIcon,
  TabHomeIcon,
  TabPlusIcon,
  TabProfileIcon,
  TabReferralIcon,
} from '../../../assets/icons/icons';
import { triggerImpactHaptic } from '../../../assets/utils/hapticFeedback';
import ChooseCardSheet from '../ChooseCardSheet/ChooseCardSheet';
import './BottomTabBar.css';

const LEFT_TABS = [
  { id: 'home', labelKey: 'home', Icon: TabHomeIcon },
  { id: 'history', labelKey: 'history', Icon: TabHistoryIcon },
];

const RIGHT_TABS = [
  { id: 'referral', labelKey: 'referral', Icon: TabReferralIcon },
  { id: 'profile', labelKey: 'profile', Icon: TabProfileIcon },
];

function TabItem({ id, label, Icon, activeTab, onTabChange, allowActiveTabChange }) {
  const handleClick = () => {
    if (id === activeTab && !allowActiveTabChange) {
      return;
    }

    triggerImpactHaptic('light');
    onTabChange?.(id);
  };

  return (
    <button
      type="button"
      className={
        id === activeTab
          ? 'bottom-tab-bar__item bottom-tab-bar__item--active'
          : 'bottom-tab-bar__item'
      }
      aria-current={id === activeTab ? 'page' : undefined}
      onClick={handleClick}
    >
      <Icon className="bottom-tab-bar__icon" />
      <span className="bottom-tab-bar__label">{label}</span>
    </button>
  );
}

function BottomTabBar({
  activeTab = 'home',
  onTabChange,
  allowActiveTabChange = false,
}) {
  const [showDepositSheet, setShowDepositSheet] = useState(false);
  const { navigation } = useContext(TranslationContext);
  const openDepositSheet = () => {
    triggerImpactHaptic('light');
    setShowDepositSheet(true);
  };

  return (
    <>
      <nav className="bottom-tab-bar" aria-label={navigation.main}>
        <button
          type="button"
          className="bottom-tab-bar__fab"
          aria-label={navigation.topUp}
          onClick={openDepositSheet}
        >
          <TabPlusIcon className="bottom-tab-bar__fab-icon" />
        </button>

        <div className="bottom-tab-bar__panel">
          <div className="bottom-tab-bar__group">
            {LEFT_TABS.map((tab) => (
              <TabItem
                key={tab.id}
                {...tab}
                label={navigation[tab.labelKey]}
                activeTab={activeTab}
                onTabChange={onTabChange}
                allowActiveTabChange={allowActiveTabChange}
              />
            ))}
          </div>
          <div className="bottom-tab-bar__group">
            {RIGHT_TABS.map((tab) => (
              <TabItem
                key={tab.id}
                {...tab}
                label={navigation[tab.labelKey]}
                activeTab={activeTab}
                onTabChange={onTabChange}
                allowActiveTabChange={allowActiveTabChange}
              />
            ))}
          </div>
        </div>
      </nav>

      <AnimatePresence>
        {showDepositSheet && (
          <ChooseCardSheet onClose={() => setShowDepositSheet(false)} />
        )}
      </AnimatePresence>
    </>
  );
}

export default BottomTabBar;
